let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eFgz4")).then(() => parcelRequire('leaRj'));